/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetTarfRequestStatusesResponse = {
    properties: {
        statuses: {
    type: 'array',
    contains: {
        type: 'TarfStatusDetail',
    },
},
    },
};